// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36bac445","616":"aac98842"}[chunkId] + ".chunk.js";
};